import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import Panel from "./panel"
import GroupsPanel from "components/compare-groups-panel"
import CollapsePanel from "components/compare-collapse-panel"
import "./styles.scss"

function CompareFrontierTables({
  data,
  items,
  columns,
  groups,
  selectedGroup,
  setGroup,
  saveGroupToStore,
  storeName,
  trackPanelTrigger,
}) {
  return <Paper className="components_compare-frontier-tables" square elevation={0}>
    <h2>Forecast</h2>
    <CollapsePanel item={items.forecast} columns={columns} data={data} trackPanelTrigger={trackPanelTrigger} />
    <h2>Risk Decomposition (%)</h2>
    <Panel items={items.risk} columns={columns} data={data} />
    <h2>Composition Summary</h2>
    <Panel items={items.summary} columns={columns} data={data} />
    <GroupsPanel
      items={items.groups}
      columns={columns}
      data={data}
      groups={groups}
      selectedGroup={selectedGroup}
      setGroup={setGroup}
      saveGroupToStore={saveGroupToStore}
      storeName={storeName}
    />
  </Paper>
}

CompareFrontierTables.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  items: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  selectedGroup: PropTypes.object.isRequired,
  setGroup: PropTypes.func.isRequired,
  trackPanelTrigger: PropTypes.func.isRequired,
  saveGroupToStore: PropTypes.func.isRequired,
  storeName: PropTypes.string.isRequired,
}

export default CompareFrontierTables
